<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-6">
          <z-input
            v-model="orgCode"
            name="orgCode"
            label="Group Code"
            validate="required"
            :inline="true"
            :inlineSize="7"
            @keyup="isSave = true"
          />
        </div>
        <div class="col-md-6">
          <div class="form-group custom-check">
            <input
              type="checkbox"
              id="isActive"
              v-model="isActive"
              class="z-checkbox-small"
              @click="isSave = true"
            />
            <label for="isActive" class="custom-allow">active?</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <z-input
            v-model="name"
            name="name"
            label="Name"
            validate="required"
            :inline="true"
            :inlineSize="7"
            @keyup="isSave = true"
          />
        </div>
        <div class="col-md-6">
          <z-input
            v-model="displayName"
            name="displayName"
            label="Display Name"
            :inline="true"
            :inlineSize="7"
            @keyup="isSave = true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <z-input
            v-model="startDate"
            name="startDate"
            label="Start"
            validate="required"
            type="date"
            :inline="true"
            :inlineSize="7"
            @keyup="isSave = true"
          />
        </div>
        <div class="col-md-6">
          <z-input
            v-model="endDate"
            name="endDate"
            label="End"
            validate="required"
            type="date"
            :inline="true"
            :inlineSize="7"
            @keyup="isSave = true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <z-input
            v-model="lowerPercent"
            name="lowerPercent"
            label="Lower Percent"
            validate="required"
            type="number"
            class="custom-number"
            :inline="true"
            :inlineSize="7"
            @keyup="isSave = true"
          />
        </div>
        <div class="col-md-6">
          <z-input
            v-model="upperPercent"
            name="upperPercent"
            label="Upper Percent"
            validate="required"
            type="number"
            class="custom-number"
            :inline="true"
            :inlineSize="7"
            @keyup="isSave = true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <z-input
            v-model="calories"
            name="calories"
            label="Calories"
            type="number"
            class="custom-number"
            :inline="true"
            :inlineSize="7"
            @keyup="isSave = true"
          />
        </div>
        <div class="col-md-6">
          <!-- <z-input
            v-model="hrmax"
            name="hrmax"
            label="HR max"
            type="number"
            class="custom-number"
            :inline="true"
            :inlineSize="7"
            @keyup="isSave = true"
          /> -->
        </div>
      </div>
      <div class="row custom-cardio-row">
        <div class="col-md-12">
          <cardio-goals
            ref="cardioGoals"
            class="custom-cardio"
            :zone="cardioGoals"
            :isEnabled="true"
            :noSave="true"
            @saveIt="isSave = true"
          />
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1">
          <span>#{{ id }}</span>
        </div>
        <div class="col-md-6">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-5">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              @click="performSave(false)"
            >
              Save
            </button>
            <!-- <button
              v-show="isSave"
              class="btn btn-primary me-2"
              @click="performSave(true)"
            >
              Save and Close
            </button> -->
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZDialog from '@/Components/ZElements/Dialog'
import ZInput from '@/Components/ZElements/Input'
import CardioGoals from '@/Components/UserCardio/elements/cardio-goals'
export default {
  name: 'program-dialog',
  components: {
    ZDialog,
    ZInput,
    CardioGoals,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      validErrors: [],
      invalidMessage: '',
      cardioGoals: {
        totalMinutes: 0,
        belowMinutes: 0,
        inMinutes: 0,
        aboveMinutes: 0,
        belowPercent: 0,
        inPercent: 0,
        abovePercent: 0,
        belowRange: '',
        inRange: '',
        aboveRange: '',
        maxHR: 0,
      },
    }
  },
  mounted() {
    this.setCardioGoals()
    console.log('Loaded Program', this.program)
  },
  watch: {
    program() {
      this.setCardioGoals()
    },
  },
  computed: {
    ...mapGetters('programs', ['program', 'orgcode']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Edit Program'
      if (this.show) {
        if (this.show.isAdd) {
          _title = 'Add Program'
        } else if (this.program) {
          _title = `Edit Program (${this.program.Name})`
        }
      }
      return _title
    },
    isAdd() {
      let _is = false
      if (this.show) {
        _is = this.show.isAdd
      }
      return _is
    },
    id() {
      let _id = ''
      if (this.program) {
        _id = this.program.id
      }
      return _id
    },
    orgCode: {
      get() {
        let _data = ''
        _data = this.orgcode
        return _data
      },
      set(value) {
        this.setProgramData({
          name: 'orgCode',
          value: value,
        })
      },
    },
    displayName: {
      get() {
        let _data = ''
        if (this.program) {
          _data = this.program.DisplayName
        }
        return _data
      },
      set(value) {
        this.setProgramData({
          name: 'displayName',
          value: value,
        })
      },
    },
    endDate: {
      get() {
        let _data = ''
        if (this.program) {
          _data = moment(new Date(this.program.EndDate)).format('YYYY-MM-DD')
        }
        return _data
      },
      set(value) {
        this.setProgramData({
          name: 'endDate',
          value: value,
        })
      },
    },
    calories: {
      get() {
        let _data = ''
        if (this.program) {
          _data = this.program.GoalCardioCalories
        }
        return _data
      },
      set(value) {
        this.setProgramData({
          name: 'calories',
          value: value,
        })
      },
    },
    // hrmax: {
    //   get() {
    //     let _data = ''
    //     if (this.program) {
    //       _data = this.program.HRmax
    //     }
    //     return _data
    //   },
    //   set(value) {
    //     this.setProgramData({
    //       name: 'hrmax',
    //       value: value,
    //     })
    //   },
    // },
    isActive: {
      get() {
        let _data = false
        if (this.program) {
          _data = this.program.IsActive
        }
        return _data
      },
      set(value) {
        this.setProgramData({
          name: 'isActive',
          value: value,
        })
      },
    },
    lowerPercent: {
      get() {
        let _data = ''
        if (this.program) {
          _data = this.program.LowerPercent
        }
        return _data
      },
      set(value) {
        this.setProgramData({
          name: 'lowerPercent',
          value: value,
        })
      },
    },
    name: {
      get() {
        let _data = ''
        if (this.program) {
          _data = this.program.Name
        }
        return _data
      },
      set(value) {
        this.setProgramData({
          name: 'name',
          value: value,
        })
      },
    },
    startDate: {
      get() {
        let _data = ''
        if (this.program) {
          _data = moment(new Date(this.program.StartDate)).format('YYYY-MM-DD')
        }
        return _data
      },
      set(value) {
        this.setProgramData({
          name: 'startDate',
          value: value,
        })
      },
    },
    upperPercent: {
      get() {
        let _data = ''
        if (this.program) {
          _data = this.program.UpperPercent
        }
        return _data
      },
      set(value) {
        this.setProgramData({
          name: 'upperPercent',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('programs', ['setProgramData', 'saveProgram']),
    initCardioGoals() {
      this.cardioGoals = {
        totalMinutes: 0,
        belowMinutes: 0,
        inMinutes: 0,
        aboveMinutes: 0,
        belowPercent: 0,
        inPercent: 0,
        abovePercent: 0,
        belowRange: '',
        inRange: '',
        aboveRange: '',
        maxHR: 0,
      }
    },
    setCardioGoals(id) {
      this.initCardioGoals()
      if (this.program) {
        this.cardioGoals.belowMinutes = parseFloat(
          this.program.MinutesBelowZone
        )
        this.cardioGoals.inMinutes = parseFloat(this.program.MinutesInZone)
        this.cardioGoals.aboveMinutes = parseFloat(
          this.program.MinutesAboveZone
        )
        this.cardioGoals.totalMinutes =
          this.cardioGoals.belowMinutes +
          this.cardioGoals.inMinutes +
          this.cardioGoals.aboveMinutes
        if (this.cardioGoals.totalMinutes > 0) {
          this.cardioGoals.belowPercent = parseFloat(
            (this.cardioGoals.belowMinutes / this.cardioGoals.totalMinutes) *
              100
          )
          this.cardioGoals.inPercent = parseFloat(
            (this.cardioGoals.inMinutes / this.cardioGoals.totalMinutes) * 100
          )
          this.cardioGoals.abovePercent = parseFloat(
            (this.cardioGoals.aboveMinutes / this.cardioGoals.totalMinutes) *
              100
          )
        }
        this.cardioGoals.maxHR = this.program.HRmax
        this.cardioGoals.belowRange = null
        this.cardioGoals.inRange = null
        this.cardioGoals.aboveRange = null
        this.cardioGoals.totalMinutes = this.cardioGoals.totalMinutes.toFixed(1)
        this.cardioGoals.belowMinutes = this.cardioGoals.belowMinutes.toFixed(1)
        this.cardioGoals.inMinutes = this.cardioGoals.inMinutes.toFixed(1)
        this.cardioGoals.aboveMinutes = this.cardioGoals.aboveMinutes.toFixed(1)
        this.cardioGoals.belowPercent = this.cardioGoals.belowPercent.toFixed(0)
        this.cardioGoals.inPercent = this.cardioGoals.inPercent.toFixed(0)
        this.cardioGoals.abovePercent = this.cardioGoals.abovePercent.toFixed(0)
      }
    },
    validate() {
      let valid = true
      this.validErrors = []
      this.invalidMessage = ''
      if (this.program.name === '') {
        valid = false
        this.validErrors.push('name')
      }
      if (this.program.displayName === '') {
        valid = false
        this.validErrors.push('display name')
      }
      if (this.program.startDate === null) {
        valid = false
        this.validErrors.push('start')
      }
      if (this.program.endDate === null) {
        valid = false
        this.validErrors.push('end')
      }
      return valid
    },
    async performSave(closeIt) {
      this.invalidMessage = ''
      let success = false
      let valid = this.validate()
      if (valid) {
        this.setProgramData({
          name: 'minutesAboveZone',
          value: this.cardioGoals.aboveMinutes,
        })
        this.setProgramData({
          name: 'minutesBelowZone',
          value: this.cardioGoals.belowMinutes,
        })
        this.setProgramData({
          name: 'minutesInZone',
          value: this.cardioGoals.inMinutes,
        })
        this.setProgramData({
          name: 'hrmax',
          value: this.cardioGoals.maxHR,
        })
        // Save Here
        console.log('Save Program', this.program)
        let results = await this.saveProgram(this.program)
        console.log('Saved Program Results', results)
        if (results.error) {
          this.invalidMessage = results.error
        } else {
          success = true
          this.isSave = false
          this.$emit('saved')
          // if (closeIt || this.show.isAdd) {
          //   this.$emit('close')
          // }
        }
      }
      return success
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-cardio-row {
  margin-top: 5px;
  border-top: 1px solid #dee2e6;
  padding-top: 5px;
}
.custom-cardio {
  padding: 5px;
}
</style>
